import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import PixelateImage from '../../components/PixelateImage';

const PixelatePage: React.FC = () => (
  <ToolLayout
    title="Pixelate Image Online Free | AllTools"
    description="Pixelate images with multiple styles. Standard, diamond, and circle pixelation modes. Free online tool."
    canonicalPath="/pixelate-image"
  >
    <PixelateImage />
  </ToolLayout>
);

export default PixelatePage;
